module.exports = "/images/magazine.svg?40d44f9a918e8c9e11c30d71b9829c27";